export default [
  { key: "hr", name: "Hrvatski" },
  { key: "en", name: "English" },
];
